import React from "react";
import { Select } from 'antd';

const { Option } = Select;

export default class SelectComponent extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = { data: props.data, selected: props.selected, inActive: props.inActive, id: props.id };
  }

  onChange = (e) => {

    let flg;

    if (this.state.id === "tipoReclamo") {
      this.state.data.forEach(valor => {
        if (valor.cod_tipo_reclamo === e) {
          flg = valor.flg;
        }
      });
      this.props.onChange(e, flg)
    } else {
      this.props.onChange(e)
    }

  }

  render() {

    let data;
    let selected;
    let options;
    if (this.state.selected > -1) {
      selected = this.state.selected;
    }

    switch (this.state.id) {
      case "motivo":
        data = this.state.data;
        options = data.map((e) => (<Option key={e.cod_motivo} value={e.cod_motivo}>{e.descripcion_motivo}</Option>));
        break;
      case "subMotivo":
        data = this.state.data;
        options = data.map((e) => (<Option key={e.cod_submotivo} value={e.cod_submotivo}>{e.descripcion}</Option>));
        break;
      case "tipoReclamo":
        data = this.state.data;
        options = data.map((e) => (<Option key={e.cod_tipo_reclamo} value={e.cod_tipo_reclamo}>{e.descropcion_reclamo}</Option>));
        break;
      case "bancos":
        data = this.state.data;
        options = data.map((e) => (<Option key={e.id} value={e.id}>{e.nombre}</Option>));    
        break;
      case "cuentas":
        data = this.state.data;
        options = data.map((e) => (<Option key={e.id} value={e.id}>{e.nombre}</Option>));
        break;
      default:
        break;
    }

    let inActive = this.state.inActive;
    return (
      <>
        <Select
          showSearch
          allowClear
          defaultValue={selected}
          id={this.state.id}
          className="select-consulta"
          style={{ width: '100%' }}
          placeholder="-- Seleccionar --"
          optionFilterProp="children"
          onChange={this.onChange}
          disabled={inActive}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }>
          {options}
        </Select>
      </>
    );
  }
}